<template id="CTAForm">
    <div class="cta-form-container" :style="cssVars">
        <form @submit.prevent="submit" novalidate>
            <h3 class="text-center" v-html="form_heading"></h3>
            <div class="row justify-content-md-center">
                <div class="col-lg-6 col-md-8 col-sm-12">
                    <div v-for="(field, id) in form_fields" :key="id">
                        <transition name="jump">
                            <component v-if="(form_type === 'step' && step >= id) || form_type === 'classic'" :v="$v.form_data[id].user_input" :disabled="is_disabled" :field="field.settings" :field_id="unique_id()" v-model="form_data[id].user_input" :is="field.type" />
                        </transition>
                    </div>
                    <transition name="jump">
                        <re-captcha :v="$v.form_data.recaptcha" :field_id="unique_id()" :disabled="is_disabled" v-model="form_data.recaptcha" v-if="require_recaptcha && (form_type === 'classic' || (step+1) == form_fields.length)"></re-captcha>
                    </transition>
                </div>
            </div>
            <div class="row justify-content-md-center">
                <transition name="fade">
                <div class="col-12" v-if="user_consent && (form_type === 'classic' || (step+1) == form_fields.length)">
                    <div class="user-concent mb-3 small text-mutted text-center" v-html="user_consent"></div>
                </div>
                </transition>
                <div class="col-12 text-center" v-if="(form_type === 'classic' || (step+1) == form_fields.length)">
                    <transition name="fade">
                        <button type="submit" class="cta-form-button btn btn-lg animate__animated" v-if="!is_disabled" 
                        data-toggle="tooltip" data-placement="top" data-type="form-submission"
                        :data-original-title="has_errors? $t('i18n.detailsAreMissing') : ''" :class="[{ 'btn-gradient btn-primary' : !form_main_color }]" 
                        :style="[button_text_color? {'color': button_text_color} : '', button_bg_color? {'background-color': button_bg_color} : '']">{{  button_text }}</button>
                    </transition>
                    <transition name="jump">
                        <div class="cta-successful" v-if="is_disabled">
                            <button class="cta-btn-success btn btn-lg btn-success animate__animated" v-html="svg('check')"></button>
                            <h3 class="mt-3" v-if="form.success_message">{{ form.success_message }}</h3>
                        </div>
                    </transition>
                </div>
                <div class="col-lg-6 col-md-8 col-sm-12 text-right" v-else>
                    <button type="button" class="cta-form-next btn btn-sm animate__animated" @click="next" :class="[{ 'btn-gradient btn-primary' : !form_main_color }]" :style="[button_text_color? {'color': button_text_color} : '', button_bg_color? {'background-color': button_bg_color} : '']">{{  $t('i18n.next') }}</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { required, sameAs, email } from "vuelidate/lib/validators";
import emailField from "../elements/emailField";
import fullnameField from "../elements/fullnameField";
import phoneField from "../elements/phoneField";
import textField from "../elements/textField";
import textareaField from "../elements/textareaField";
import checkboxField from "../elements/checkboxField";
import selectField from "../elements/selectField";
import reCaptcha from "../elements/reCaptcha";

const uuid = require('uuid');

export default {
    props: {
        data: {
            required: true,
            default: function () {
                return {};
            },
        },
        block_id: {
            type: String,
            default: ''
        },
        result: {
            type: String,
            required: false,
            default: ''
        },
        post_id: {
            type: Number,
            default: ''
        }
    },
    components: {
        emailField,
        fullnameField,
        phoneField,
        textField,
        textareaField,
        checkboxField,
        selectField,
        reCaptcha,
    },
    data() {
        return {
            is_disabled: false,
            form: {
                form_type: "classic",
                form_trigger: "after",
                recaptcha: true,
                consent: this.$t("i18n.consentData"),
                fields: [],
                heading: "",
                button_text: "",
                color: false,
                text_color: false,
            },
            step: 0,
            form_data: [],
        };
    },
    created() {
        this.syncForm(this.data);
    },
    computed: {
        form_main_color: function () {
            return this.convert_color(this.form.color);
        },
        button_bg_color: function () {
            return this.convert_color(this.form.color);
        },
        button_text_color: function () {
            return this.convert_color(this.form.text_color);
        },
        form_type: function() {
            return this.form.form_type
        },
        cssVars: function () {
            return {
                "--form-main-color": this.convert_color(this.form.color),
            };
        },
        button_text: function () {
            return this.form.button_text;
        },
        form_fields: function () {
            return this.form.fields;
        },
        form_heading: function () {
            return this.form.heading;
        },
        user_consent: function () {
            return this.form.consent;
        },
        has_errors: function() {
            return this.$v.form_data.$pending || this.$v.form_data.$error;
        },
        require_recaptcha: function() {
            return this.form.recaptcha && this.$variables.has_recaptcha
        },
        
    },
    validations() {
        return this.validation_rules();
    },
    methods: {
        syncForm: function (data) {
            const $this = this;
            this.form = Object.assign({}, this.form, data);
            this.form.fields.forEach(function (item, index) {
                let $data = {
                    label: item.settings.label,
                    user_input: item.type == "checkbox-field"? false : '',
                };
                $this.form_data.push($data);
            });
        },
        validation_rules: function () {
            let rules = { form_data: {} };
            const $this = this;
            this.form.fields.forEach(function (item, index) {
                if(item.type == 'email-field') {
                    if(item.settings.required) {
                        rules.form_data[index] = {
                            user_input: {
                                required,
                                email
                            },
                        };
                    } else {
                        rules.form_data[index] = {
                            user_input: {
                                email
                            },
                        };
                    }
                } else if(item.type === 'checkbox-field' && item.settings.required) {
                    rules.form_data[index] = {
                        user_input: {
                            sameAs: sameAs( () => true )
                        },
                    };
                } else if(item.settings.required) {
                    rules.form_data[index] = {
                        user_input: {
                            required
                        },
                    };
                } else {
                    rules.form_data[index] = {user_input: {}};
                }

                if($this.require_recaptcha) {
                    rules.form_data.recaptcha = {
                        required
                    }
                }
            });

            return rules;
        },
        convert_color: function (colors, fallback = null) {
            if (typeof colors === "string") {
                return colors;
            }

            return colors && typeof colors.hex !== "undefined"
                ? colors.hex
                : false;
        },
        unique_id: function() {
            return uuid.v4()
        },
        next: function(e) {
            e.preventDefault();
            this.$v.form_data[this.step].$touch();

            if(!this.$v.form_data[this.step].$error) {
                this.step++
            }
        },
        submit() {
            this.$v.form_data.$touch();
            if (this.has_errors || this.is_disabled) return;

            const url = this.$variables.lead_form || false;
            if(url) {
                var action = {};
                action['form'] = this.form_data;
                action['g-recaptcha-response'] = this.form_data.recaptcha;
                action['block'] = this.block_id;
                if(this.result) {
                    action['result'] = this.result;
                }
                axios.post(url, action).then(res => {
                    if(res.data.success) {
                        this.is_disabled = true;
                        this.$emit("lead-captured");
                    } else {
                        this.returnErrorMsg(res.data)
                    }
                }).catch(err => {
                    this.returnErrorMsg(err.response.data)
                });
            }
        },
        returnErrorMsg(msgs) {
            if(msgs.errors) {
                var ul = document.createElement('ul');
                ul.className = "p-0";
                const errors = msgs.errors;
                Object.keys(errors).forEach(function (key) {
                    var li = document.createElement('li');
                    ul.appendChild(li);
                    li.innerHTML += errors[key][0];
                });
                
                self.Quizier.sweetErrors(ul.outerHTML);
            } else {
                const $msg = msgs.message || this.$t('i18n.somethingWentWrong')

                self.Quizier.sweetError($msg)
            }

        }
    },
};
</script>

<style scoped>
.cta-form-container .form-control:focus {
    border-color: var(--form-main-color);
}
</style>